<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div>
    <v-card-title>
      <v-spacer/>
      <v-text-field
        v-model="presearch"
        append-icon="search"
        label="Buscar"
        single-line
        hide-details
      />
    </v-card-title>
    <v-data-table
      :headers="headers"
      :items="rowItems"
      :pagination.sync="pagination"
      :total-items="totalItems"
      :loading="loading"
      :rows-per-page-items="[5,10,25,50]"
      disable-initial-sort
    >
      <template v-slot:items="props">
        <tr>
          <td  class="text-xs-left px-2">
            {{ props.item.fecha }}
          </td>
          <td   class="text-xs-left px-2">
            {{ props.item.nombre_completo }}
          </td>
          <td  class="text-xs-left px-2">
            {{ props.item.numero_empleado }}
          </td>
          <td  class="text-xs-left px-2">
            {{ props.item.placas }}
          </td>
          <td   class="text-xs-left px-2">
            {{ props.item.empresa }}
          </td>
          <td  class="text-xs-left px-2">
            {{ props.item.gerencia }}
          </td>
          <td  class="text-xs-left px-2">
            {{ props.item.puesto }}
          </td>
          <td  class="text-xs-left px-2">
            {{ props.item.acceso }}
          </td>
          <td  class="text-xs-left px-2">
            {{ props.item.portico }}
          </td>
          <td class="justify-center layout px-0">
            <v-btn v-if="props.item.tiene_fotos" flat icon  @click="get_acceso_detalles(props.item)">
              <v-icon>description</v-icon>
            </v-btn>
          </td>
        </tr>
      </template>
    </v-data-table>
    <v-dialog
      v-model="dialogDetalles"
      persistent
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <v-card>
        <v-toolbar class="py-0 subheading" dark color="primary">
          FOTOS ACCESO
          <v-spacer></v-spacer>
          <v-btn flat icon
                 @click="close_dialog_detalles()">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-container grid-list-md fluid>
          <v-layout row wrap>
            <v-flex xs12 sm4 md4 >
              <img v-if="this.$store.getters['historicoAccesosColaboradores/faceImage'] != null"
                :src="decode_base64(this.$store.getters['historicoAccesosColaboradores/faceImage'])"
                style="width: 95%"
                alt="foto_rostro"/>
            </v-flex>
            <v-flex xs12 sm4 md4 >
              <img v-if="this.$store.getters['historicoAccesosColaboradores/credentialImage'] != null"
                   :src="decode_base64(this.$store.getters['historicoAccesosColaboradores/credentialImage'])"
                   style="width: 95%"
                   alt="foto_credencial"/>
            </v-flex>
            <v-flex xs12 sm4 md4 >
              <img v-if="this.$store.getters['historicoAccesosColaboradores/backCredentialImage'] != null"
                   :src="decode_base64(this.$store.getters['historicoAccesosColaboradores/backCredentialImage'])"
                   style="width: 95%"
                   alt="foto_credencial_trasera"/>
            </v-flex>
            <v-flex xs12 sm4 md4 >
              <img v-if="this.$store.getters['historicoAccesosColaboradores/frontImage'] != null"
                :src="decode_base64(this.$store.getters['historicoAccesosColaboradores/frontImage'])"
                style="width: 95%"
                alt="foto_frente"/>
            </v-flex>
            <v-flex xs12 sm4 md4 >
              <img v-if="this.$store.getters['historicoAccesosColaboradores/sideImage'] != null"
                   :src="decode_base64(this.$store.getters['historicoAccesosColaboradores/sideImage'])"
                   style="width: 95%"
                   alt="foto_lado"/>
            </v-flex>
            <v-flex xs12 sm4 md4 >
              <img v-if="this.$store.getters['historicoAccesosColaboradores/backImage'] != null"
                   :src="decode_base64(this.$store.getters['historicoAccesosColaboradores/backImage'])"
                   style="width: 95%"
                   alt="foto_trasera"/>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { getJWTData } from '../common/jwt.service';
import moment from '../../node_modules/moment';

export default {
  data: () => ({
    text_required_rules: [
      v => !!v || 'Requerido',
    ],
    timer: '',
    presearch: '',
    searchTimer: null,
    loading: true,
    totalItems: 0,
    rowItems: [],
    search: '',
    frontImageData: null,
    pagination: {},
    expand: false,
    dialogDetalles: false,
    normal_headers: [
      {
        text: 'Fecha', value: 'fecha', sortable: true, width: '100px', class: 'px-2',
      },
      {
        text: 'Nombre', value: 'nombre_completo', sortable: true, class: 'px-2',
      },
      {
        text: 'NDE', value: 'numero_empleado', sortable: true, class: 'px-2',
      },
      {
        text: 'Placas', value: 'placas', sortable: true, class: 'px-2',
      },
      {
        text: 'Empresa', value: 'empresa', sortable: true, class: 'px-2',
      },
      {
        text: 'Gerencia', value: 'gerencia', sortable: true, width: '50px', class: 'px-2',
      },
      {
        text: 'Puesto', value: 'puesto', sortable: true, width: '50px', class: 'px-2',
      },
      {
        text: 'Acceso', value: 'acceso', sortable: true, class: 'px-2',
      },
      {
        text: 'Pórtico', value: 'portico', sortable: true, class: 'px-2',
      },
      {
        text: 'Acciones', value: 'name', sortable: false, class: 'px-0',
      },
    ],
  }),
  computed: {
    folios() {
      return this.$store.getters['historicoAccesosColaboradores/accesos_list'];
    },
    alertType() {
      return this.$store.getters['historicoAccesosColaboradores/revoke_alertType'];
    },
    alertMessage() {
      return this.$store.getters['historicoAccesosColaboradores/revoke_alertMessage'];
    },
    alert() {
      return this.$store.getters['historicoAccesosColaboradores/revoke_alert'];
    },
    headers() {
      const data = getJWTData();
      if (data.user_claims.limitado) {
        return this.limited_headers;
      }
      return this.normal_headers;
    },
  },
  watch: {
    pagination: {
      handler() {
        this.getDataFromApi()
          .then((data) => {
            this.rowItems = data.items;
            this.totalItems = data.total;
          });
      },
      deep: true,
    },
    search() {
      this.getDataFromApi()
        .then((data) => {
          this.rowItems = data.items;
          this.totalItems = data.total;
        });
    },
    presearch() {
      this.cancelSearchTimer();
      this.searchTimer = setInterval(this.updateSearch, 1000);
    },
  },
  beforeDestroy() {
    this.cancelAutoUpdate();
    this.cancelSearchTimer();
  },
  created() {
    this.user_login_role = getJWTData().user_claims.role;
    this.timer = setInterval(this.fetchEventsList, 60000);
  },
  methods: {
    getDataFromApi() {
      this.loading = true;
      return new Promise((resolve, reject) => {
        const {
          sortBy, descending, page, rowsPerPage,
        } = this.pagination;

        const formdata = {
          page,
          per_page: rowsPerPage,
          search: this.search,
          order_by: sortBy,
          descending,
        };
        this.$store.dispatch('historicoAccesosColaboradores/fetchAccesos', formdata)
          .then(() => {
            this.loading = false;
            const items = this.$store.getters['historicoAccesosColaboradores/accesos_list'];
            const total = this.$store.getters['historicoAccesosColaboradores/accesos_total'];

            this.$store.commit('historicoAccesosColaboradores/fetchedAccesos');
            resolve({
              items,
              total,
            });
          });
      });
    },
    is_admin() {
      if (['admin', 'jefe_monitoristas', 'monitoristas'].includes(this.user_login_role)) {
        return true;
      }
      return false;
    },
    get_acceso_detalles(formdata) {
      this.dialogDetalles = true;
      if (formdata.foto_frontal != null) {
        this.$store.dispatch('historicoAccesosColaboradores/fetchFrontImage', formdata.foto_frontal);
      }
      if (formdata.foto_lateral != null) {
        this.$store.dispatch('historicoAccesosColaboradores/fetchSideImage', formdata.foto_lateral);
      }
      if (formdata.foto_trasera != null) {
        this.$store.dispatch('historicoAccesosColaboradores/fetchBackImage', formdata.foto_trasera);
      }
      if (formdata.foto_rostro != null) {
        this.$store.dispatch('historicoAccesosColaboradores/fetchFaceImage', formdata.foto_rostro);
      }
      if (formdata.foto_credencial_frente != null) {
        this.$store.dispatch('historicoAccesosColaboradores/fetchCredentialImage', formdata.foto_credencial_frente);
      }
      if (formdata.foto_credencial_trasera != null) {
        this.$store.dispatch('historicoAccesosColaboradores/fetchBackCredentialImage', formdata.foto_credencial_trasera);
      }
    },
    close_dialog_detalles() {
      this.dialogDetalles = false;
      this.$store.commit('historicoAccesosColaboradores/clearImages');
    },
    updateSearch() {
      if (this.presearch !== this.search) {
        this.search = this.presearch;
      }
    },
    fetchEventsList() {
      if (!this.$store.getters['historicoAccesosColaboradores/loading_accesos']) {
        this.$store.dispatch('historicoAccesosColaboradores/clearAccesosAction');
        this.getDataFromApi();
      }
    },
    cancelAutoUpdate() { clearInterval(this.timer); },
    cancelSearchTimer() {
      if (this.searchTimer !== null) {
        clearInterval(this.searchTimer);
      }
    },
    decode_base64(encoded) {
      const base = 'data:image/jpeg;base64, ';
      if (encoded !== null) {
        return base.concat(encoded);
      }
      return null;
    },
    formatter_date(fecha, formato = 'DD-MM-YYYY') {
      return moment(fecha).format(formato);
    },
    formatter_time(hora, formato = 'HH:mm') {
      return moment(hora, 'HH:mm:ss').format(formato);
    },
    formatter_date_range(desde, hasta, formato = 'DD-MM-YYYY') {
      return `${this.formatter_date(desde, formato)} al ${this.formatter_date(hasta, formato)}`;
    },
    formatter_time_range(desde, hasta, formato = 'HH:mm') {
      return `${this.formatter_time(desde, formato)} a ${this.formatter_time(hasta, formato)}`;
    },
    formatter_dias_vigencia(acceso) {
      let html = '';
      if (acceso.lunes === true) {
        html += 'Lunes ';
      }
      if (acceso.martes === true) {
        html += 'Martes ';
      }
      if (acceso.miercoles === true) {
        html += 'Miércoles ';
      }
      if (acceso.jueves === true) {
        html += 'Jueves ';
      }
      if (acceso.viernes === true) {
        html += 'Viernes ';
      }
      if (acceso.sabado === true) {
        html += 'Sábado ';
      }
      if (acceso.domingo === true) {
        html += 'Domingo ';
      }
      return html;
    },
  },
};
</script>
